import { Navigate, RouteObject } from 'react-router-dom';
import Admin from '.';
import RedemptionLinks from './RedemptionLinks';
import Reports from './Reports';
import AccountSelect from './AccountSelect';
import AdminPortalInitializer from '../shared/navigation/AdminPortalInitializer';
import TwoFactorAuthCallback from '../shared/navigation/TwoFactorAuthCallback';
import Settings from './Settings';
import People from './People';
import ProductDetailsReport from './Reports/ProductDetailsReport';
import Invoices from './Invoices';
import AdminLogs from './AdminLogs';
import SessionCheck from '../shared/navigation/SessionCheck';
import AgreementDetails from './Dashboard/AgreementDetails';
import Dashboard from './Dashboard';
import OrderHistory from './OrderHistory';
import AdminOrderConfirmation from './OrderHistory/AdminOrderConfirmation';

const routes: RouteObject[] = [
  {
    path: '/admin',
    element: <SessionCheck render={() => <Admin />} />,
    children: [
      {
        path: 'select-account',
        element: <AccountSelect />,
      },
      {
        path: 'account-2fa/:accountId/:dealId',
        element: <TwoFactorAuthCallback />,
      },
      {
        path: 'account-2fa/:accountId',
        element: <TwoFactorAuthCallback />,
      },
      {
        path: '',
        element: <Navigate to="/admin/select-account" />,
      },
      {
        path: ':accountId/:dealId',
        element: (
          <AdminPortalInitializer
            render={() => <AgreementDetails />}
            pageName="Home"
          />
        ),
      },
      {
        path: ':accountId',
        element: (
          <AdminPortalInitializer
            render={() => <Dashboard />}
            pageName="Home"
          />
        ),
      },
      {
        path: ':accountId/redemption-links',
        element: <AdminPortalInitializer render={() => <RedemptionLinks />} />,
      },
      {
        path: ':accountId/people',
        element: (
          <AdminPortalInitializer render={() => <People />} pageName="People" />
        ),
      },
      {
        path: ':accountId/people/*',
        element: (
          <AdminPortalInitializer
            render={() => <Navigate to="/admin/people" />}
          />
        ),
      },
      {
        path: ':accountId/users/list',
        element: (
          <AdminPortalInitializer
            render={() => <Navigate to="/admin/people" />}
          />
        ),
      },
      {
        path: ':accountId/reports/:dealId',
        element: (
          <AdminPortalInitializer
            render={() => <Reports />}
            pageName="Reports"
          />
        ),
      },
      {
        path: ':accountId/reports/:dealId/:dateRange',
        element: (
          <AdminPortalInitializer
            render={() => <Reports />}
            pageName="Reports"
          />
        ),
      },
      {
        path: ':accountId/reports',
        element: (
          <AdminPortalInitializer
            render={() => <Reports />}
            pageName="Reports"
          />
        ),
      },
      {
        path: ':accountId/reports/deal/:dealId/sku/:productId',
        element: (
          <AdminPortalInitializer
            render={() => <ProductDetailsReport />}
            pageName="Reports"
          />
        ),
      },
      {
        path: ':accountId/reports/deal/:dealId/sku/:productId/:dateRange',
        element: (
          <AdminPortalInitializer
            render={() => <ProductDetailsReport />}
            pageName="Reports"
          />
        ),
      },
      {
        path: ':accountId/invoices/:dealId',
        element: (
          <AdminPortalInitializer
            render={() => <Invoices />}
            pageName="Invoices"
          />
        ),
      },
      {
        path: ':accountId/invoices',
        element: (
          <AdminPortalInitializer
            render={() => <Invoices />}
            pageName="Invoices"
          />
        ),
      },
      {
        path: ':accountId/settings',
        element: (
          <AdminPortalInitializer
            render={() => <Settings />}
            pageName="Settings"
          />
        ),
      },
      {
        path: ':accountId/logs',
        element: (
          <AdminPortalInitializer
            render={() => <AdminLogs />}
            pageName="Logs"
          />
        ),
      },
      {
        path: ':accountId/order-history',
        element: (
          <AdminPortalInitializer
            render={() => <OrderHistory />}
            pageName="Order History"
          />
        ),
      },
      {
        path: ':accountId/order-history/confirmation/:orderId',
        element: (
          <AdminPortalInitializer
            render={() => <AdminOrderConfirmation />}
            pageName="Order Confirmation"
          />
        ),
      },
    ],
  },
];

export default routes;
